import news from "../services/news";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        loading: false,
        news: [],
        newsDetails: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        errors: null,
        currentPage: 1,
        searching: false,
        categories: [],
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        editing: false,
        validityTime: "10:00:00"
    },
    getters: {
        getField
    },
    mutations: {
        updateField,
        loading(state, value = true) {
            state.loading = value;
        },
        editing(state, value) {
            state.editing = value;
        },
        news(state, news) {
            state.news = news;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = state.totalPerPage > 0 ? pagination.max_page : 0;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.totalPerPage > 0
                    ? state.initialPageCount * state.prevPage + 1
                    : 0;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        categories(state, categories) {
            state.categories = categories;
            state.loading = false;
        },
        searching(state, searching) {
            state.searching = searching;
            state.loading = false;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setDetails(state, details) {
            state.newsDetails = details;
        },
        setValidityTime(state, value) {
            state.validityTime = value;
        }
    },
    actions: {
        async getNews({ commit }, page) {
            commit("loading");
            try {
                // let _this = this;
                let response = await news.getNews(page);

                if (page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                await commit("news", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCategories({ commit }) {
            commit("loading");
            try {
                let response = await news.getCategories();
                commit("categories", response.categories);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async search({ commit }, param) {
            commit("loading");
            try {
                let response = await news.search(param.apiFields, param.page);
                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                commit("pagination", response);
                commit("news", response.list);
                commit("searching", true);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveNews({ commit, state }, param) {
            commit("loading");
            try {
                let response = await news.saveNews(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, Cannot create new news.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateNews({ commit, state }, data) {
            commit("loading");
            try {
                let response = await news.updateNews(data.uuid, data.param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, Cannot create new news.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteNews({ commit }, uuid) {
            commit("loading");
            try {
                let response = await news.deleteNews(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                console.log(errors);
                commit("loading", false);
            }
        },
        async viewNews({ commit }, uuid) {
            commit("loading");
            try {
                let response = await news.viewNews(uuid);
                commit("setDetails", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                console.log(errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async setValidityTime({ commit }, value) {
            commit("setValidityTime", value);
        }
    }
};
